
import React from 'react';
import { Navbar, Home, YesPage } from "./components"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} /> 
        <Route path="/yes" element={<YesPage />} />
      </Routes>
    </Router>
  );
}

export default App;